import { PROCEDURETYPE } from "@/backend/models/procedureInstances/procedureInstanceBase";
import { useParameterHasCorrectInputType, useGetRefAndParameterByConsumer, useCreateSourceReference, buildSelectableParameters } from "@/frontend/hooks/parameters";
import { useParameterStore } from "@/frontend/store/ParameterStore";
import { BoxArrowUpRight } from "@/frontend/SVGs/BoxArrowUpRight";
import { I18n } from "@/i18n/I18n";
import { Link } from "react-router-dom";
import { GenericParameterSelect } from "./GenericParameterSelect";
import { Parameter } from "@/backend/models/parameter";
import { Form } from "react-bootstrap";
import { useProcedureInstanceStore } from "@/frontend/store/ProcedureInstanceStore";
import { useTreeStore } from "@/frontend/store/TreeStore";
import { embedOnlyLink } from "@/frontend/embed/embedApp";


export function AssignValueFromSelect(props: { parameter: Parameter, selectableParameters: Parameter[] }) {
  const { parameter, selectableParameters } = props;
  const operations = useTreeStore(state => state.operations);
  const parameterHasCorrectInputType = useParameterHasCorrectInputType(parameter.inputType);
  const parameters = buildSelectableParameters(selectableParameters, operations)
  .filter(param => param.fieldType === parameter.fieldType && parameterHasCorrectInputType(param));

  const { currentReference, currentParameter } = useGetRefAndParameterByConsumer(parameter.id);
  const createReference = useCreateSourceReference(parameter.id);
  const deleteReference = useParameterStore(state => state.deleteReference);
  const procedure = useProcedureInstanceStore(state => state.procedureInstance);
  // A template's parameters live in the template editor, which only the embed app serves.
  const parameterLink = currentParameter && (procedure?.procedureType === PROCEDURETYPE.TEMPLATE
    ? embedOnlyLink(`/procedures/scaffold/${procedure?.id}#${currentParameter.id}`)
    : `/procedures/edit/${procedure?.id}#${currentParameter.id}`);

  return (
    <div className='flex-shrink'>
      <Form.Label className="col-form-label col-form-label-sm">{I18n.get('assignValueFrom')}:</Form.Label>
      <div className='d-flex gap-1 min-w-0'>
        <GenericParameterSelect parameters={parameters} currentParameter={currentParameter} currentReference={currentReference} createReference={createReference} deleteReference={(id) => void deleteReference(id)} />
        { parameterLink && <Link to={parameterLink} aria-label={I18n.get('goToParameter')}><BoxArrowUpRight /></Link> }
      </div>
    </div>
  );
}
